import React from 'react';
import { FieldErrors } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

export type ErrorRenderViewProps = {
  //
  className?: string;
  component?: string;
  errors: FieldErrors | undefined;
  name: string;
};

export const ErrorRenderView = (props: ErrorRenderViewProps): JSX.Element => {
  const { component, className, errors, name } = props;

  const getProps = (key: string) => ({
    key,
    ...(className ? { className } : {})
  });

  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ messages, message }) => {
        if (!messages && message) {
          messages = { message };
        }
        return messages
          ? Object.entries(messages).map(([type, message]) =>
              React.createElement(component ?? 'p', getProps(type), message)
            )
          : undefined;
      }}
    />
  );
};
